import React, { ChangeEvent, Fragment, useEffect, useState } from 'react';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import {
  Box,
  Button,
  Card,
  CardHeader,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  Select,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import FilterListIcon from '@mui/icons-material/FilterList';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { TableColumnCell } from 'src/components/TableColumnCell';
import { useForm } from 'react-hook-form';
import {
  deleteStakeholder,
  getAllCustomers,
  getAllStakeholders,
  getSegments,
  searchStakeholders
} from 'src/services/projectService';
import ToggleModal from './ToggleModal';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import { AppActions } from 'src/store/AppReducer';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/hooks/hooks';
import {
  getRolePermissions
} from 'src/services/authService';
import SnackBar from 'src/components/SnackBar/SnackBar';
import { validateMultiRolesAndPermissions } from 'src/utils/validate';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';

interface Filters {
  stakeholderName: string;
  code: string;
  designation: string;
  contact: string;
}

const applyFilters = (employees: any[], filters: Filters): any[] => {
  return employees.filter((employeeStatus) => {
    let matches = true;
    // if (filters.status && employeeStatus.status !== filters.status) {
    //   matches = false;
    // }
    return matches;
  });
};

const applyPagination = (
  employees: any[],
  page: number,
  limit: number
): any[] => {
  return employees.slice(page * limit, page * limit + limit);
};

const StakeholdersView = () => {
  const dispatch = useDispatch();

  const [filters] = useState<Filters>({
    stakeholderName: null,
    code: null,
    designation: null,
    contact: null
  });
  const { isLoading } = useAppSelector((state) => state.appReducer);
  var initalList: any[] = [];
  const [stakeholders, setStakeholders] = useState(initalList);
  const [allStakeholders, setAllStakeholders] = useState(initalList);

  const [segments, setSegments] = useState<any>([]);
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);

  const [expand, setExpand] = useState<any>();
  const [expandCus, setExpandCus] = useState<any>();

  const handleExpand = (code) => {
    setExpand(
      {
        id: code,
        expand: expand?.id === code ? !expand.expand : true
      }
    );
  }

  const handleExpandCus = (code) => {
    setExpandCus(
      {
        id: code,
        expand: expandCus?.id === code ? !expandCus.expand : true
      }
    );
  }


  const filteredStakeholders = applyFilters(stakeholders, filters);
  const paginatedStakeholders = applyPagination(
    filteredStakeholders,
    page,
    limit
  );
  const navigate = useNavigate();
   
  const [permissions, setPermissions] = useState([]);

  const getPermissions = (mail) => {
    getRolePermissions(mail).then((res) => {
      const tabs = validateMultiRolesAndPermissions(res);
      const arr = tabs.filter((fil) => fil.name === 'Stakeholder');
      setPermissions(arr[0].permissions);
    });
  };
  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };


  const getSegmentsCustomers = () => {
    getSegments().then((res) => {
      setSegments(res?.data);

      const result = [];
      for(let i=0;res?.data.length > i;i++){
        const customerArray = [];
        for(let j=0;res?.data[i].customers.length > j;j++){
          const customers = res?.data[i]?.customers;
          customers[j]?.stakeholders.length > 0 && customerArray.push(customers[j]);
        }
        customerArray.length > 0 && result.push({...res?.data[i], customers: customerArray});
      }

      setStakeholders(result);
      setAllStakeholders(result);
    });
  };

  useEffect(() => {
    //getStakeholderData();
    getSegmentsCustomers();
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (Object.keys(user).length === 0) {
      navigate('/');
    } else {
      getPermissions(user.Email);
    }
  }, []);

  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem'
    }
  })(TableRow);

  const [searchKeywords, setSearchKeywords] = useState('');

  //when user started to type the name in the text field
  const nameChange = (event) => {
    setSearchKeywords(event.target.value.toLowerCase());
  };

  const searchGroupsAll = async (keyword: string) => {
    dispatch(AppActions.showLoader());
    //const result = await searchStakeholders(keyword);

    const result = [];
    for(let i=0;allStakeholders.length > i;i++){
      const customerArray = [];
      for(let j=0;allStakeholders[i].customers.length > j;j++){
        const customers = allStakeholders[i]?.customers;
        const filteredStakeholder = customers[j]?.stakeholders.filter(el => el.name.toLowerCase().includes(keyword));
        filteredStakeholder.length > 0 && customerArray.push({...customers[j], stakeholders: filteredStakeholder});
      }
      customerArray.length > 0 && result.push({...allStakeholders[i], customers: customerArray});
    }
    setPage(0);
    setStakeholders(result);
    dispatch(AppActions.hideLoader());
  };

  useEffect(() => {
    if (searchKeywords.length > 0) {
      searchGroupsAll(searchKeywords);
    }
    if (searchKeywords.length === 0) {
      //getStakeholderData();
      getSegmentsCustomers();
    }
  }, [searchKeywords]);

  const [openStakeHolders, setOpenStakeHolders] = useState(false);
  const [stakeholdersEdit, setStakeholdersEdit] = useState(false);
  const [editDataStakeholder, setEditDataStakeholder] = useState<any>({});
  const [stakeholderDeleteID, setStakeholderDeleteID] = useState('');

  const toggleStakeholdersAdd = () => {
    setOpenStakeHolders(!openStakeHolders);
  };

  const [
    openConfirmationStakeholderDelete,
    setOpenConfirmationStakeholderDelete
  ] = useState(false);

  const toggleConfirmationStakeholderDelete = () => {
    setOpenConfirmationStakeholderDelete(!openConfirmationStakeholderDelete);
  };

  const deleteStakeholderFunc = () => {
    deleteStakeholder(stakeholderDeleteID)
      .then(() => {
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'You have deleted the stakeholder successfully.',
            severity: 'success'
          })
        );
        //getStakeholderData();
        getSegmentsCustomers();
        toggleConfirmationStakeholderDelete();
        // You cannot delete this stakeholder since it has associated projects.
      })
      .catch((error) => {
        console.log(error);

        if (
          error?.response?.data ===
          'An error occurred while saving the entity changes. See the inner exception for details.'
        ) {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: error.response.data,
              severity: 'error'
            })
          );
          toggleConfirmationStakeholderDelete();
        } else {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message:
                ' You cannot delete this stakeholder since it has associated projects.',
              severity: 'error'
            })
          );
          toggleConfirmationStakeholderDelete();
        }
      });
  };

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');

  return (
    <Fragment>
      <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
        <Grid item>
          <Typography
            style={{
              marginLeft: '0px',
              fontWeight: '700',
              fontSize: '16px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            Stakeholders
          </Typography>
          <Typography variant="subtitle2"></Typography>
        </Grid>
        <Grid item>
        {permissions.some((perm) =>
          perm.name === 'Edit Stakeholder' && perm.value === true
          ) &&
          <Button
            id='btn-toggleStakeholdersAdd'
            onClick={() => {
              setStakeholdersEdit(false);
              toggleStakeholdersAdd();
            }}
            sx={{
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            startIcon={<AddTwoToneIcon fontSize="small" />}
            style={{ height: '1.75rem' }}
          >
            Create New
          </Button>
        }
        </Grid>
      </Grid>
      <Card>
        <Grid
          container
          style={{
            justifyContent: 'space-between',
            padding: '1rem'
          }}
          spacing={2}
        >
          <Grid item xs={6}>
            <TextField
              id='mainSearch-stakeholderName'
              sx={{ width: 320, mr: 2 }}
              size="small"
              placeholder="Stakeholder Name"
              onChange={(e) => nameChange(e)}
              InputProps={{
                style: { fontSize: '12px', height: '1.75rem' },
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      sx={{ color: '#d3d3d3' }}
                      style={{ fontSize: '15px' }}
                    />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
        </Grid>
        <TableContainer>
          <Table style={{ borderCollapse: 'separate' }} size="small">
            <TableHead sx={{ backgroundColor: '#e6e9ff' }}>
              <CustomTableRow sx={{ py: 10 }}>
                <TableHeaderCell className='tree-button' content="" smallFont/>
                <TableHeaderCell content="Segment" smallFont />
                <TableHeaderCell className='client-padding-40' content="Client Code" smallFont />
                <TableHeaderCell content="Client" smallFont />
                <TableHeaderCell content="Stakeholder Name" smallFont />
                <TableHeaderCell content="Designation" smallFont />
                <TableHeaderCell content="Email" smallFont />
                <TableHeaderCell content="Contact Number" smallFont />
                {permissions.some(
                                (perm) =>
                                  perm.name === 'Edit Stakeholder' && perm.value === true
                              ) && 
                              <TableHeaderCell content="Actions" smallFont sticky />
                            }
              </CustomTableRow>
            </TableHead>
            <TableBody>

            {permissions.some(
                                (perm) =>
                                  perm.name === 'View Stakeholder' && perm.value === true
                              ) && 
            <>
            {paginatedStakeholders &&
                paginatedStakeholders?.length > 0 &&
                paginatedStakeholders.map((listItem, i) => {
                  return (
                    <Fragment key={listItem?.code}>
                      <TableRow  hover
                        className={(expand?.id === listItem?.code && expand?.expand) ? 'segment-row segment-selected-row' : 'segment-row'}>
                        <TableColumnCell className='tree-button'>
                          {listItem?.customers?.length > 0 &&
                            <Button
                              sx={{
                                mt: { xs: 2, md: 0 },
                                fontSize: '11px',
                                fontWeight: 'normal',
                                width: '14px',
                                height: '14px',
                                padding: 0,
                                minWidth: 'unset',
                                borderRadius: '2px',
                                cursor: 'pointer'
                              }}
                              onClick={e => handleExpand(listItem?.code)}
                              variant="contained"
                              startIcon={expand?.id === listItem?.code && expand?.expand ? <HorizontalRuleIcon fontSize="small" style={{fontSize: '14px'}}/> : 
                              <AddTwoToneIcon fontSize="small" style={{fontSize: '14px'}}/>}
                            />
                          }
                        </TableColumnCell>
                        <TableColumnCell>
                          <Typography
                            paddingBottom="0.25rem"
                            paddingTop="0.5rem"
                            style={{ fontSize: '11px' }}
                            variant="body2"
                            gutterBottom
                            noWrap
                          >
                            {listItem?.name}
                          </Typography>
                        </TableColumnCell>
                        <TableColumnCell></TableColumnCell>
                        <TableColumnCell></TableColumnCell>
                        <TableColumnCell></TableColumnCell>
                        <TableColumnCell></TableColumnCell>
                        <TableColumnCell></TableColumnCell>
                        <TableColumnCell></TableColumnCell>
                        <TableColumnCell sticky></TableColumnCell>
                      </TableRow>
                      {
                        expand?.id === listItem?.code && expand?.expand && listItem?.customers.length > 0 && 
                        listItem?.customers.map((customer, index) => {
                          return (
                            <Fragment key={customer?.id}>
                              <TableRow
                                hover
                                key={customer?.id}
                                className='customer-row'
                              >
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell>
                                  <div style={{display: 'flex', alignItems: 'center'}}>
                                    <div className='border-0' style={{width: '40px'}}>
                                      { customer?.stakeholders.length > 1 && 
                                        <Button
                                          sx={{
                                            mt: { xs: 2, md: 0 },
                                            fontSize: '11px',
                                            fontWeight: 'normal',
                                            width: '14px',
                                            height: '14px',
                                            padding: 0,
                                            minWidth: 'unset',
                                            borderRadius: '2px',
                                            cursor: 'pointer'
                                          }}
                                          onClick={e => handleExpandCus(customer?.id)}
                                          variant="contained"
                                          startIcon={expandCus?.id === customer?.id && expandCus?.expand ? <HorizontalRuleIcon fontSize="small" style={{fontSize: '14px'}}/> : 
                                          <AddTwoToneIcon fontSize="small" style={{fontSize: '14px'}}/>}
                                        />
                                      }
                                    </div>
                                    <div className='border-0'>
                                      <Typography
                                        marginBottom={0}
                                        paddingBottom="0.25rem"
                                        paddingTop="0.5rem"
                                        variant="body2"
                                        style={{ fontSize: '11px' }}
                                        color="text.primary"
                                        gutterBottom
                                        noWrap
                                      >
                                        {customer?.code}
                                      </Typography>
                                    </div>
                                  </div>
                                </TableColumnCell>
                                <TableColumnCell>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    style={{ fontSize: '11px' }}
                                    variant="body2"
                                    gutterBottom
                                    noWrap
                                  >
                                    {customer?.name}
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    style={{ fontSize: '11px' }}
                                    variant="body2"
                                    gutterBottom
                                    noWrap
                                  >
                                    {customer?.stakeholders?.length === 1 ? customer?.stakeholders[0]?.name : ''}
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    style={{ fontSize: '11px' }}
                                    variant="body2"
                                    gutterBottom
                                    noWrap
                                  >
                                    {customer?.stakeholders?.length === 1 ? customer?.stakeholders[0]?.designation : ''}
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    style={{ fontSize: '11px' }}
                                    variant="body2"
                                    gutterBottom
                                    noWrap
                                  >
                                    {customer?.stakeholders?.length === 1 ? customer?.stakeholders[0]?.email : ''}
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    style={{ fontSize: '11px' }}
                                    variant="body2"
                                    gutterBottom
                                    noWrap
                                  >
                                     {customer?.stakeholders?.length === 1 ? customer?.stakeholders[0]?.contactNumber : ''}
                                  </Typography>
                                </TableColumnCell>
                                {permissions.some(
                                        (perm) =>
                                          perm.name === 'Edit Stakeholder' && perm.value === true
                                      ) && customer?.stakeholders?.length === 1 ?
                                  <>
                                    <TableColumnCell sticky>
                                      <div
                                        style={{
                                          background: 'white',
                                          marginLeft: 'auto'
                                        }}
                                      >
                                        <Tooltip title="Edit" placement="top" >
                                        <EditIcon
                                          id={"btn-setStakeholdersEdit-" + i}
                                          onClick={() => {
                                            setStakeholdersEdit(true);
                                            setEditDataStakeholder({
                                              ...customer?.stakeholders[0],
                                              customerId: customer?.id,
                                              segmentId: listItem?.id
                                            });
                                            toggleStakeholdersAdd();
                                          }}
                                          style={{
                                            fontSize: '17px',
                                            cursor: 'pointer'
                                          }}
                                        />
                                        </Tooltip>
                                        <Tooltip title="Delete" placement="top" >
                                        <DeleteOutlineIcon
                                          id={'btn-setStakeholderDeleteID-' + i}
                                          onClick={() => {
                                            setStakeholderDeleteID(customer[0]?.id);
                                            toggleConfirmationStakeholderDelete();
                                          }}
                                          style={{
                                            fontSize: '17px',
                                            cursor: 'pointer'
                                          }}
                                        />
                                        </Tooltip>
                                      </div>
                                    </TableColumnCell>
                                  </> : 
                                  <TableColumnCell sticky></TableColumnCell>
                                }
                              </TableRow>
                              {
                                expandCus?.id === customer?.id && expandCus?.expand && customer?.stakeholders?.length > 1 && 
                                customer?.stakeholders?.map((stakeholder, index) => {
                                  return (
                                    <Fragment key={stakeholder?.id}>
                                      <TableRow
                                        hover
                                        key={stakeholder?.id}
                                        className='stakeholder-row'
                                      >
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell></TableColumnCell>
                                        <TableColumnCell>
                                          <Typography
                                            paddingBottom="0.25rem"
                                            paddingTop="0.5rem"
                                            style={{ fontSize: '11px' }}
                                            variant="body2"
                                            gutterBottom
                                            noWrap
                                          >
                                            {stakeholder?.name}
                                          </Typography>
                                        </TableColumnCell>
                                        <TableColumnCell>
                                          <Typography
                                            paddingBottom="0.25rem"
                                            paddingTop="0.5rem"
                                            style={{ fontSize: '11px' }}
                                            variant="body2"
                                            gutterBottom
                                            noWrap
                                          >
                                            {stakeholder?.designation}
                                          </Typography>
                                        </TableColumnCell>
                                        <TableColumnCell>
                                          <Typography
                                            paddingBottom="0.25rem"
                                            paddingTop="0.5rem"
                                            style={{ fontSize: '11px' }}
                                            variant="body2"
                                            gutterBottom
                                            noWrap
                                          >
                                            {stakeholder?.email}
                                          </Typography>
                                        </TableColumnCell>
                                        <TableColumnCell>
                                          <Typography
                                            paddingBottom="0.25rem"
                                            paddingTop="0.5rem"
                                            style={{ fontSize: '11px' }}
                                            variant="body2"
                                            gutterBottom
                                            noWrap
                                          >
                                            {stakeholder?.contactNumber}
                                          </Typography>
                                        </TableColumnCell>
                                        {permissions.some(
                                                (perm) =>
                                                  perm.name === 'Edit Stakeholder' && perm.value === true
                                              ) && 
                                          <>
                                            <TableColumnCell sticky>
                                              <div
                                                style={{
                                                  background: 'white',
                                                  marginLeft: 'auto'
                                                }}
                                              >
                                                <Tooltip title="Edit" placement="top" >
                                                <EditIcon
                                                  id={"btn-setStakeholdersEdit-" + i}
                                                  onClick={() => {
                                                    setStakeholdersEdit(true);
                                                    setEditDataStakeholder({
                                                      ...stakeholder,
                                                      customerId: customer?.id,
                                                      segmentId: listItem?.id
                                                    });
                                                    toggleStakeholdersAdd();
                                                  }}
                                                  style={{
                                                    fontSize: '17px',
                                                    cursor: 'pointer'
                                                  }}
                                                />
                                                </Tooltip>
                                                <Tooltip title="Delete" placement="top" >
                                                <DeleteOutlineIcon
                                                  id={'btn-setStakeholderDeleteID-' + i}
                                                  onClick={() => {
                                                    setStakeholderDeleteID(stakeholder.id);
                                                    toggleConfirmationStakeholderDelete();
                                                  }}
                                                  style={{
                                                    fontSize: '17px',
                                                    cursor: 'pointer'
                                                  }}
                                                />
                                                </Tooltip>
                                              </div>
                                            </TableColumnCell>
                                          </>
                                        }
                                      </TableRow>
                                    </Fragment>
                                  );
                                })
                              }
                            </Fragment>
                          );
                        })
                      }
                    </Fragment>
                  );
                })
              }
            </>
            }
            </TableBody>
          </Table>
        </TableContainer>
        {paginatedStakeholders?.length === 0 && (
          <Typography
            style={{
              fontSize: '15px',
              fontWeight: 'bold',
              margin: '1rem',
              textAlign: 'center'
            }}
            variant="body2"
          >
            No Records Found
          </Typography>
        )}
        <Box p={2}>
          <TablePagination
            sx={{
              fontSize: '12px',
              '.MuiTablePagination-displayedRows': {
                fontSize: '12px'
              },
              '.MuiTablePagination-selectLabel': {
                fontSize: '12px'
              }
            }}
            component="div"
            count={filteredStakeholders?.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
          />
        </Box>
      </Card>
      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />
      <ToggleModal
        open={openStakeHolders}
        toggle={toggleStakeholdersAdd}
        isEdit={stakeholdersEdit}
        getData={getSegmentsCustomers}
        data={stakeholdersEdit ? editDataStakeholder : ''}
        length={paginatedStakeholders.length}
        segments={segments}
        setSnackBarOpen={setSnackBarOpen}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackBarMessage={setSnackBarMessage}
      />
      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmationStakeholderDelete}
        toggle={toggleConfirmationStakeholderDelete}
        message={`Are you sure want to delete this stakeholder?`}
        onConfirm={() => deleteStakeholderFunc()}
        noToggle={toggleConfirmationStakeholderDelete}
      />
    </Fragment>
  );
};

export default StakeholdersView;
